import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';

export default function ServiceCard({ service }) {
  const { title, icon, image, items, categoryLabel, description } = service;

  // Resolve Lucide icon dynamically from its string code
  const IconComponent = Icons[icon] || Icons.Wrench;

  return (
    <div className="service-card">
      {/* Service Card Image Header with Bottom-Left Category Badge */}
      <div className="service-card-image-wrapper">
        <img 
          src={image} 
          alt={`${title} solutions by Vijay Industry in Coimbatore, Tamil Nadu`} 
          className="service-card-image"
          loading="lazy"
        />
        <span className="service-card-img-badge">{categoryLabel}</span>
      </div>

      {/* Service Card Content */}
      <div className="service-card-content">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.25rem' }}>
          {/* Soft square icon box */}
          <div className="service-card-icon-box" aria-hidden="true">
            <IconComponent size={20} />
          </div>
          <h3 style={{ margin: 0, minHeight: 'auto' }}>{title}</h3>
        </div>

        {/* Short description for richer detail */}
        <p className="service-card-description">
          {description}
        </p>
        
        {/* Services checklist formatted as a vertical compact list */}
        <div className="service-list-items" aria-label={`Solutions under ${title}`}>
          {items.map((item, index) => (
            <div key={index} className="service-list-item">
              <Icons.CheckCircle2 size={14} className="service-list-icon" />
              <span>{item}</span>
            </div>
          ))}
        </div>

        {/* Card Footer Call to Action */}
        <Link to="/contact" className="service-card-cta" aria-label={`Request a quote for ${title}`}>
          Request Quote <span>&rarr;</span>
        </Link>
      </div>
    </div>
  );
}
